<template>
    <div name="complete-contract" class="page">
            <confirm-modal 
                v-if="isBackButton"
                @onClose="onBackConfirmNo"
                @onYes="onBackConfirmYes"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../../../assets/arrow_back.png" />
            </div>
            <steps
                :isStepper="true"
                :step="2"
                :title="'청구 위임장을 작성해 주세요'"
            />
            <div style="width: 100%;">
                <span class="title">💡 질환 유형</span>
                    <div class="text-box" style="margin-bottom: 8px;">
                    <span class="text" v-if="draftProfile.diabetes_type === 'TYPE1'">1형 당뇨</span>
                    <span class="text" v-else-if="draftProfile.diabetes_type === 'GESTATIONAL'">임신성 당뇨 (인슐린 투여)</span>
                    <span class="text" v-else-if="draftProfile.diabetes_type === 'GESTATIONAL_WITHOUT_INSULIN'">임신성 당뇨 (인슐린 미투여)</span>
                    <span class="text" v-else-if="draftProfile.diabetes_type === 'SELF_CATHETER'">자가도뇨 카테터 대상자</span>
                    <span class="text" v-else-if="draftProfile.diabetes_type === 'RARE_INTRACTABLE'">희귀난치성질환 대상자</span>
                    <span class="text" v-else>2형 당뇨</span>
                    </div>
                <span class="title"  v-if="!duplicateDelegation">💡 국민건강보험에 위임될 청구 내역</span>
                <span class="title"  v-else>💡 국민건강보험에 위임된 청구 내역</span>
                <div class="text-box">
                    <span class="label">위임 기간 (최대 5년)</span>
                    <span class="text" >{{ convertDate(delegateWithAddition.started_at) }} ~ {{ convertDate(delegateWithAddition.expired_at) }}</span>
                    <!-- 신규 위임일 경우 -->                    
                    <span class="label" style="margin-top: 16px;">위임일</span>
                    <span class="text">{{ convertDate(delegateWithAddition.started_at) }}</span>
                    <span class="label" style="margin-top: 20px;">위임사항</span>
                    <span v-if="draftProfile.diabetes_type !== 'SELF_CATHETER'" class="text">당뇨병 소모성재료, 연속혈당측정용 전극(센서)<span v-if="draftProfile.diabetes_type === 'TYPE1'">, 연속혈당측정기, 인슐린자동주입기</span></span>
                    <span v-else class="text">자가도뇨 소모성 재료</span>
                </div>
            </div>
            <div style="text-align: center; margin-top: 40px;width: 100%;">
                <span class="text-info"><span class="bold">생성된 위임장이 있습니다!</span><br/>
                    위임장 재작성이 필요한 경우 고객센터로 문의해주세요.</span>
                <bottom-button 
                    :text="'다음 단계'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="completeContract"
                    style="margin-top: 8px;"
                />     
            </div>
    </div>
</template>

<script>
// 임시 저장이 완료된 후 다음 단계로 이동하기 위한 페이지 
// 뒤로가기 불가 
import Steps from '@/components/molecules/Steps'
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import BottomButton from '@/components/atoms/BottomButton';
import PageFooter from '@/components/molecules/PageFooter';
import Constant from '@/constant';
import ErrorModal from '@/components/modals/ErrorModal';
import Loading from '@/components/molecules/Loading';
import ConfirmModal from '@/components/modals/ConfirmModal';
import CommonModal from '@/components/modals/CommonModal';

export default {
    name: 'completeContract',
    computed: mapState(['delegateWithAddition', 'pre_delegation_info', 'draftProfile']),
    props: ['duplicateDelegation'],
    components: {
        Steps,
        BottomButton,
        ConfirmModal
    },
    data() {
        return {
            isBackButton: false
        }
    },
    methods: {
        onBackConfirmYes: function()
        {
            // 모든 state, file 초기화, request 초기화 
            this.$store.commit(Constant.INITIALIZE_DELEGATE_WITH_ADDITION);
            this.$router.push('/register')
        },
        onBackConfirmNo: function()
        {
            this.isBackButton = false
        },

        completeContract: function()
        {
            this.$emit('completeContract')
        },
         convertDate: function(date)
        {   
            return `${date.substring(0, 4)}년 ${date.substring(5, 7)}월 ${date.substring(8, 10)}일`;
        },
        back: function()
        {
            this.isBackButton = true;

        }
    }
}
</script>

<style scoped>
    .page {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        position: relative;
        overflow-y: auto;
        height: 100dvh;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            overflow-y: auto;
            height: 100dvh;
        }
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .text-box {
        width: 100%;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px;
        margin-top: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-top: 8px;
    }
    .label {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text-info {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.42px;
        text-align: center;
    }
    .bold {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/CompleteContract.vue